import axios from "axios";

const putLabUserUpdate = async (baseUrl, token, smscode, newPassword) => {

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    let putResponse = null

    await axios.put(baseUrl + `/lab/password/update?token=` + smscode + "&newpassword=" + newPassword, {}, config)
        .then((res) => {
            putResponse = {
                status: res.status,
                result: res.data.data
            }
        }).catch((error) => {
            if (error.response !== undefined) {
                putResponse = {
                    status: error.response.status,
                    result:  error.response.status
                }
            }
        });
    return putResponse
}

export default putLabUserUpdate;